import { Api } from "../helpers";

export const languageService = {
  getAll,
};

// get all languages regardless of anything
function getAll() {
  return Api()
    .get("/languages/all")
    .then((response) => {
      // return all languages
      // [{id: 1, name: "English", shortName: "en"}, {id: 2, name: "French", shortName: "fr"},…]
      return response.data.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
